import Cookies from "js-cookie";

export const save = (name: any, value: any) => {
  return Cookies.set(name, value);
};

export const saveSecure =  (name: any, value: any) => {
    Cookies.set(name, value, { secure: true });
};

// Method to get data from cookies
export const load = (name: any) => {
  return Cookies.get(name);
};

// Method to remove data from cookies
export const remove = (name: any) => {
  Cookies.remove(name);
};

